import Vue from 'vue';

Vue.component('status-widget-component', {
    /**
     * Vue.js instance reactive data variables.
     *
     * @return {Object}
     */
    data() {
        return {
            weather: null,
            status: null,
        };
    },

    mounted() {
        // Fetch status
        this.fetchStatus();

        // Fetch weather
        this.fetchWeather();
    },

    /**
     * Vue.js instance methods.
     *
     * @type {Object}
     */
    methods: {
        fetchWeather() {
            axios.get('/actions/open-weather/default')
            .then((response) => {
                if (response.status !== 200) {
                    throw response.data.error;
                }

                this.weather = response.data;
            })
            .catch((error) => {
                // handle error
                console.log(error);
            });
        },

        fetchStatus() {
            this.$api.gms.general.getStatus()
            .then((response) => {
                this.status = response;
            })
            .catch((error) => {
                console.log(error);
            });
        },
    },
});
